"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var InputText_1 = __importDefault(require("../../../InputText"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Transfer = function (_a) {
    var method = _a.method;
    var fields = method.fields.filter(function (f) { return f.name !== 'withdrawal.amount'; });
    var getField = function (field) { return fields.find(function (f) { return f.name === field; }); };
    var iban = getField('customer.iban_account_number');
    var firstName = getField('customer.first_name');
    var lastName = getField('customer.last_name');
    var bank = getField('customer.bank');
    var swift = getField('customer.bic_swift');
    var bankAddress = getField('customer.bank_address');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        iban && react_1.default.createElement(InputField, { field: iban }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            firstName && react_1.default.createElement(InputField, { field: firstName }),
            lastName && react_1.default.createElement(InputField, { field: lastName })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.rowPart },
            bank && react_1.default.createElement(InputField, { field: bank }),
            swift && react_1.default.createElement(InputField, { field: swift })),
        bankAddress && react_1.default.createElement(InputField, { field: bankAddress })));
};
var InputField = function (_a) {
    var field = _a.field;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(react_final_form_1.Field, { name: field.type, key: "field_name_".concat(field.type) }, function (_a) {
        var input = _a.input, meta = _a.meta;
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
            react_1.default.createElement(InputText_1.default, __assign({ labelText: t("".concat(field.name, ".title")), id: field.type, placeholder: t("".concat(field.name, ".placeholder")), type: field.type, helpertext: meta.error && meta.touched
                    ? { status: 'error', text: meta.error }
                    : undefined }, input))));
    }));
};
exports.default = Transfer;
